module.exports = __webpack_public_path__ + "static/media/payment.bc8fdcd6.png";